import { StateNode, TLPointerEventInfo } from "tldraw"

export class MarkerIdle extends StateNode {
  static override id = "marker-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("marker-drawing", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "none", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
